import { useContext } from "react";
import { FeatureFlagContext } from "../context/FeatureFlagsContext";

export const useFeatureFlagContext = () => useContext(FeatureFlagContext);
